import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../common/theme/ISpcTheme';

export type TransferModalClasses = 'dialogContent';

const transferModalStyles = makeStyles<ISpcTheme, TransferModalClasses>(
  () => ({
    dialogContent: {
      padding: '8px 0 0 0',
    },
  }),
  { name: 'GQL_Stock_TransferModal' },
);

export default transferModalStyles;
